export default function getCroppedImg(imageSrc, crop) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imageSrc;
      img.crossOrigin = "anonymous";
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");
  
        ctx.drawImage(
          img,
          crop.x,
          crop.y,
          crop.width,
          crop.height,
          0,
          0,
          crop.width,
          crop.height
        );
  
        canvas.toBlob((blob) => {
          if (!blob) {
            reject("Canvas is empty");
            return;
          }
  
          const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
          const preview = URL.createObjectURL(blob);
  
          resolve({ blob, file, preview });
        }, "image/jpeg");
      };
  
      img.onerror = reject;
    });
  }
  